export default "__VITE_ASSET__C7tkQsZ2__"